// Menú móvil
const botonMenuMovil = document.querySelector('.menu-movil');
const navMovil = document.querySelector('.nav-movil');
const botonCerrarMenu = document.querySelector('.cerrar-menu');

botonMenuMovil.addEventListener('click', () => {
    navMovil.classList.add('activo');
    document.body.style.overflow = 'hidden';
});

botonCerrarMenu.addEventListener('click', () => {
    navMovil.classList.remove('activo');
    document.body.style.overflow = '';
});

// Cerrar el menú al hacer click en un enlace
const enlacesNavMovil = navMovil.querySelectorAll('a');
enlacesNavMovil.forEach(enlace => {
    enlace.addEventListener('click', () => {
        navMovil.classList.remove('activo');
        document.body.style.overflow = '';
    });
});
